import { MeetingRoute } from '@/modules/meeting/routes/MeetingRoute';
import { MeetingRouteConfig } from '@/modules/meeting/routes/MeetingRouteConfig';

export const router: MeetingRouteConfig[] = [
  // @ts-ignore
  MeetingRouteConfig.factory({
    name: MeetingRoute.MEETINGS.name,
    path: `/${MeetingRoute.MEETINGS.path}`,
    component: () => import('/@/modules/meeting/pages/MeetingDashboardPage.vue')
  }).build()
];
